import { Box, Chip, Grid, Link, Stack, Typography } from "@mui/material";

const Council = () => {
  const years = [
    {
      year: "2024",
      committee_url: "#",
    },
    {
      year: "2023",
      committee_url: "#",
    },
    {
      year: "2022",
      committee_url: "#",
    },
    {
      year: "2021",
      committee_url: "#",
    },
    {
      year: "2020",
      committee_url: "#",
    },
  ];
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography fontSize={16}>
          Formation of the Student Council at Modern College of Physiotherapy
          adheres strictly to the guidelines outlined by the Maharashtra
          University of Health Sciences (MUHS). This representative body is
          constituted to provide a platform for students to voice their
          opinions, contribute to college decisions, and engage in
          extracurricular activities.
        </Typography>
        <Typography fontSize={16}>
          The council plays a pivotal role in fostering a vibrant campus life
          and promoting student welfare. The selection process for council
          members involves transparent elections or nominations, ensuring
          inclusivity and democratic representation. The elected council is
          entrusted with organizing academic, cultural, and sports events,
          addressing student concerns, and maintaining effective communication
          between students and the college administration. By adhering to the
          MUHS framework, the college ensures that the student council functions
          as a dynamic force in shaping the overall college experiences.
        </Typography>
        <Grid
          container
          textAlign="left"
          alignSelf="start"
          mt={{ xs: "24px !important", md: "32px !important" }}
        >
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              Committees
            </Typography>
          </Grid>
          <Grid container spacing={2} mt={2}>
            {years?.map((item) => (
              <Grid item key={item.year} xs="auto">
                <Chip
                  label={item.year}
                  variant="filled"
                  color="secondary"
                  component={Link}
                  href={item?.committee_url}
                  sx={{
                    cursor: "pointer",
                    border: "2px solid",
                    padding: "8px 16px",
                    borderRadius: "16px",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      opacity: 0.8,
                      color: "inherit",
                      backgroundColor: "transparent",
                      border: "2px solid",
                      borderColor: "secondary.main",
                      "& .MuiChip-label": {
                        textDecoration: "underline",
                      },
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default Council;
